<template>
  <f7-page id="tnc-page" name="tnc-page" @page:afterin="afterin">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link @click="goBack()" class="customBack" color="black"><i class="f7-icons">chevron_left</i></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>
    <f7-block>
      <div class="col-70 text-align-left mb-xl">
          <div class="wandr-title-1 wandr-level-2">{{$t('regis-tnc')}}</div>
          <!-- <div class="wandr-subtitle-1">{{$t('general-text-updated')}} {{updatedDate}}</div> -->
      </div>
			<div class="static-content" v-html="tncContent.details">
			</div>
    </f7-block>
  </f7-page>
</template>

<style scoped>
em{
  font-style: italic;
}

</style>

<script>
  import { mapGetters } from "vuex";
  //import ApiService from '../services/api-main';
  import { translation } from '@/plugins/i18n'

  export default {
    mounted (){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      const moment= require('moment');
      let formattedMonth = moment(mm, 'M').locale(translation.currentLanguage).format('MMMM');


      this.updatedDate = dd + ' ' + formattedMonth + ' ' + yyyy;
      this.loadTNC();

      console.log("TnC page, AXS ? "+this.isAxsr)
    },

    data() {
      return {
          tncContent: [],
          updatedDate: '',
      };
    },
    methods: {
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async loadTNC(){ 

        const self = this;
        self.showPreloader();

        //console.log("TnC page, loadTNC ? "+self.isAxsr)
          
        const loadTnc =  await this.$api.registration.getTnc(0, 36);
        self.tncContent = loadTnc;
        console.log(loadTnc);

        self.hidePreloader();
      },

      goBack() {
        if(this.isAxsr){
          this.$f7router.navigate("/axsr-login");
        }else{
          this.$f7router.back({ transition: 'f7-push' });
        }
      },
    },

    components: {
 
    },

    computed: {
      ...mapGetters('registration', ['isAxsr'])
    },
  }
</script>
